<template>
    <v-app id="login">
        <v-content>
            <v-container class="fill-height" fluid>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="8" md="4">
                        <v-card class="elevation-12">
                            <v-toolbar color="#E6007E" dark flat>
                                <v-toolbar-title>Sallys Blog</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form>
                                    <v-text-field
                                            label="Login"
                                            name="login"
                                            prepend-icon="mdi-account"
                                            type="text"
                                            v-model="username"
                                    />

                                    <v-text-field
                                            v-model="password"
                                            id="password"
                                            label="Password"
                                            name="password"
                                            prepend-icon="mdi-lock"
                                            type="password"
                                    />
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="primary" @click="login()">Login</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
  //import { auth } from '../lib/auth';

  export default {
    name: 'Login',
    data() {
      return {
        username: "",
        password: "",
      }
    },
    methods: {
      login() {
        let that = this;
        //this.$router.push('Dashboard');
        this.$store.dispatch('loginAction',{login: this.username,password: this.password});
        if( that.$store.getters.isAuthenticated !== null){
          that.$router.push('Posts');
        }
      }
    },
    watch:{
      password: function(val) {
        this.password = val;
      },
      username: function (val) {
        this.username = val;
      }
    }
  }
</script>

<style>

    @primary = '#E6007E';
</style>